module.exports = __webpack_public_path__ + "img/upgrader.9a489c7d.webp";